import { render } from "./MineActivities.vue?vue&type=template&id=643061fc&scoped=true"
import script from "./_MineActivities.js?vue&type=script&lang=js"
export * from "./_MineActivities.js?vue&type=script&lang=js"

import "./_MineActivities.less?vue&type=style&index=0&id=643061fc&lang=less&scoped=true"

import exportComponent from "/home/aichat/aichat-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643061fc"]])

export default __exports__